<template lang="pug">
  div
    //div
      svg.lines(:class="{ 'hovered' : chopped_motorcycle }", version='1.1', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', x='0px', y='0px', viewBox='0 0 1200 1200', style='enable-background:new 0 0 1200 1200', xml:space='preserve')
        g.st0
          polygon.st1(points='600,600 569.83,0 630.18,0 	')
          polygon.st1(points='600,600 466.1,14.35 525.53,3.88 	')
          polygon.st1(points='600,600 366.43,46.5 423.14,25.86 	')
          polygon.st1(points='600,600 273.87,95.47 326.13,65.3 	')
          polygon.st1(points='600,600 191.21,159.77 237.44,120.98 	')
          polygon.st1(points='600,600 120.98,237.44 159.77,191.21 	')
          polygon.st1(points='600,600 65.3,326.13 95.47,273.87 	')
          polygon.st1(points='600,600 25.86,423.14 46.51,366.43 	')
          polygon.st1(points='600,600 3.88,525.53 14.35,466.09 	')
          polygon.st1(points='600,600 0,630.17 0,569.82 	')
          polygon.st1(points='600,600 14.35,733.9 3.87,674.47 	')
          polygon.st1(points='600,600 46.5,833.57 25.86,776.85 	')
          polygon.st1(points='600,600 95.47,926.13 65.3,873.87 	')
          polygon.st1(points='600,600 159.77,1008.79 120.97,962.55 	')
          polygon.st1(points='600,600 237.44,1079.02 191.21,1040.23 	')
          polygon.st1(points='600,600 326.13,1134.7 273.87,1104.53 	')
          polygon.st1(points='600,600 423.14,1174.13 366.43,1153.49 	')
          polygon.st1(points='600,600 525.53,1196.12 466.09,1185.64 	')
          polygon.st1(points='600,600 630.17,1200 569.82,1200 	')
          polygon.st1(points='600,600 733.9,1185.64 674.47,1196.12 	')
          polygon.st1(points='600,600 833.57,1153.49 776.85,1174.14 	')
          polygon.st1(points='600,600 926.13,1104.53 873.87,1134.7 	')
          polygon.st1(points='600,600 1008.79,1040.23 962.56,1079.02 	')
          polygon.st1(points='600,600 1079.02,962.56 1040.23,1008.79 	')
          polygon.st1(points='600,600 1134.7,873.87 1104.53,926.13 	')
          polygon.st1(points='600,600 1174.13,776.86 1153.49,833.57 	')
          polygon.st1(points='600,600 1196.12,674.47 1185.64,733.91 	')
          polygon.st1(points='600,600 1200,569.83 1200,630.18 	')
          polygon.st1(points='600,600 1185.64,466.1 1196.12,525.53 	')
          polygon.st1(points='600,600 1153.49,366.43 1174.14,423.15 	')
          polygon.st1(points='600,600 1104.53,273.87 1134.7,326.14 	')
          polygon.st1(points='600,600 1040.23,191.21 1079.02,237.45 	')
          polygon.st1(points='600,600 962.56,120.98 1008.79,159.77 	')
          polygon.st1(points='600,600 873.87,65.3 926.13,95.47 	')
          polygon.st1(points='600,600 776.86,25.87 833.57,46.51 	')
          polygon.st1(points='600,600 674.47,3.88 733.91,14.36 	')
    //.bike-container(@mouseover='handleChopped()', @mouseout='handleChopped()')
      img.bike(src="../../../images/tvs_moto.png")
      img.shadow(src="../../../images/tvs_moto_shadow.png")
    .info-concurso
      .container
        .info-text
          .info-small La Cámara de Comercio de Montería te lleva a:
        .columns(style="margin: 0px 20px;")
          .column.is-full-mobile(style="margin: 20px 0px;")
            .columns
              .column.image-beach.andr
              .column.text-beach.andr
          .column.is-full-mobile(style="margin: 20px 0px;")
            .columns
              .column.image-beach.cart
              .column.text-beach.cart
        .info-text
          .info-block Participas Renovando a Tiempo
          .info-small Tu Matrícula Mercantil y de Entidad Sin Ánimo de Lucro vigencia 2020
          .info-small ¡Son 3 viajes, 3 sorteos, un viaje a San Andrés Islas y dos a Cartagena!
</template>

<script>
export default {
  data() {
    return {
      chopped_motorcycle: false
    }
  },
  computed: {
    rangeDate() {
      switch (moment().month()) {
        case 0:
          return `${moment().startOf('month').date(2).format('LL')} HASTA EL ${moment().endOf('month').format('LL')}`
        case 1:
          return `${moment().startOf('month').format('LL')} HASTA EL ${moment().endOf('month').format('LL')}`
        case 2:
          return `${moment().startOf('month').format('LL')} HASTA EL ${moment().endOf('month').format('LL')}`
        default:
          return ''
      }
    }
  },
  methods: {
    handleChopped() {
      let vm = this
      vm.chopped_motorcycle = !vm.chopped_motorcycle
    }
  }
}
</script>

<style lang="sass" scoped>
  .range-date
    text-transform: uppercase
  .bold
    font-weight: bold
  .light
    font-weight: 300
  .st0
    opacity: 0.1
  .st1
    fill: #FFFFFF
  .fil2, .fil0, .fil1
    fill: #5c6bc0
    fill-rule: nonzero
    fill-opacity: .7
  .info-text
    max-width: 600px
    margin: auto
    text-align: center
    background: radial-gradient(circle farthest-corner at 200px 0,#6971b1, #555b8e)
    -webkit-background-clip: text
    -webkit-text-fill-color: transparent
    .info-block
      font-family: "Montserrat-BlackItalic"
      font-size: 1.9rem
    .info-small
      font-family: "Montserrat-MediumItalic"
      font-size: 1.3rem
  .lines
    position: fixed
    top: 50%
    left: 50%
    transform: translate(-50%, -50%) rotate(0deg)
    animation: 1s linesBackground ease
    width: 200%
    height: 200%
    z-index: -1
    transition: all 1s ease
    &.hovered
      transform: translate(-50%, -50%) rotate(30deg)
  .content-lines
    animation: 90s moveLines linear infinite
    animation-delay: 1s
  .bike-container
    width: 400px
    margin: auto
    animation: 1s moveBike ease-out
    position: relative
    z-index: 3
    text-align: center
    &:hover
      & .bike
        transform: rotate(14deg)
      & .shadow
        transform: scale(.6)
    & .bike
      transition: all .3s ease
      transform-origin: 285px 330px
    & .shadow
      position: absolute
      top: 0
      left: 0
      transition: all .3s ease
      transform-origin: 285px 362px
  .info-concurso
    background: #fff
    min-height: 200px
    //transform: skewY(-5deg) translateY(-94px)
    position: relative
    padding: 2em 20px 2em 20px
    //border-top: 10px solid #FFB216
    &:after, &:before
      width: 220px
      height: 220px
      position: absolute
      background-size: cover !important
      background-repeat: no-repeat !important
      background-position: center !important
      opacity: .2
    &:after
      content: ''
      //background: url(../../../images/points_triangle.svg)
      top: 0
      left: 0

    &:before
      content: ''
      //background: url(../../../images/points_triangle.svg)
      bottom: -157px
      right: -64px
      transform: rotate(157deg)
  .description-concurso
    & svg
      margin: 20px 0
  .text-beach
    margin: 20px 10px
    height: 300px
    background-repeat: no-repeat
    background-position: center
    background-size: contain
    &.andr
      background-image: url(../../../images/assets2020/destinos-01.svg)
    &.cart
      background-image: url(../../../images/assets2020/destinos-02.svg)
  .image-beach
    margin: 20px 10px
    height: 300px
    background-repeat: no-repeat
    background-position: center
    background-size: contain
    transition: .3s 
    &.andr
      background-image: url(../../../images/assets2020/destinos-01.png)
      &:hover,&:focus
        filter: drop-shadow(5px 5px 10px rgba(0,0,0,.3))
        transform: rotate(10deg) scale(1.5)
    &.cart
      background-image: url(../../../images/assets2020/destinos-02.png)
      &:hover,&:focus
        filter: drop-shadow(5px 5px 10px rgba(0,0,0,.3))
        transform: rotate(10deg) scale(1.5)
</style>



// WEBPACK FOOTER //
// resources/js/components/PageConcurso2020/LinesMotorbike.vue